import * as Yup from 'yup'

function parseRuDate(value) {
  if (!value || value.length !== 10) {
    return null
  }

  const [day, month, year] = value.split('.').map(Number)
  if (!day || !month || !year) {
    return null
  }

  const date = new Date(year, month - 1, day)
  if (
    date.getFullYear() !== year
    || date.getMonth() !== month - 1
    || date.getDate() !== day
  ) {
    return null
  }

  return date
}

Yup.addMethod(Yup.string, 'dateValidate', function (errorMessage) {
  return this.test('dateValidate', errorMessage, function (value) {
    if (!value || value === '') {
      return true
    }

    const {path, createError} = this
    const date = parseRuDate(value)

    return date ? true : createError({path, message: errorMessage})
  })
})

Yup.addMethod(Yup.string, 'birthdayValidate', function (errorMessage) {
  return this.test('birthdayValidate', errorMessage, function (value) {
    if (!value || value === '') {
      return true
    }

    const {path, createError} = this
    const date = parseRuDate(value)

    if (!date) {
      return createError({path, message: errorMessage})
    }

    const minDate = new Date(1900, 0, 1)
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (date < minDate || date >= today) {
      return createError({path, message: errorMessage})
    }

    return true
  })
})

Yup.addMethod(Yup.string, 'email', function () {
  return this.matches(/^ *[A-Za-z0-9а-яА-Я\._-]+@([A-Za-z0-9а-яА-Я]{1,2}|[A-Za-z0-9а-яА-Я]((?!(\.\.))[A-Za-z0-9а-яА-Я.-])+[A-Za-z0-9а-яА-Я])\.[A-Za-zа-яА-Я]{2,} *$/, {
    name: 'email',
    message: 'Некорректный email',
    excludeEmptyString: true,
  })
})
